export default __webpack_public_path__ + "static/media/tagme2.4c962841.jpg";